import { Container } from './Container';
import { Dots } from './Dots';
import { AvatarSlot } from './AvatarSlot';

export default {
  Container,
  Dots,
  AvatarSlot,
};
